// extracted by mini-css-extract-plugin
module.exports = {"hero":"SEOMetricsHero_hero___Fc4T","textWrapper":"SEOMetricsHero_textWrapper__V28R5"};